<template>
  <div
    class="settle-accounts-detail"
    v-loading="isLoadPage"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <SiruiSearch
            ref="formItem"
            :query="baseFormData"
            :columns="formColumn"
            :isQueryPanel="false"
            :rules="formRules"
            @changeMethod="changeMethod"
            :isDisabledForm="!isCreate"
          >
          </SiruiSearch>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            结算行
          </div>
        </template>
        <div class="collapse-content">
          <SettleAccountsRowTable
            :baseFormData="baseFormData"
            @selectionRowHandler="selectionRowHandler"
            @closeEditTableHandler="closeEditRowTableHandler"
            @deleteRowDataHandler="deleteRowDataHandler"
            ref="settleAccountsRowTableRef"
            :fetchTableData="settleAccountsRowList"
            :isCreate="isCreate"
            :defaultSelection="defaultSelection"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="3" v-if="Object.keys(currentSettleAccountRowData).length">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            结算明细
          </div>
        </template>
        <div class="collapse-content">
          <SettleAccountsDetailTable
            :baseFormData="baseFormData"
            :fetchTableData="currentSettleAccountDetailList"
            :currentSettleAccountRowData="currentSettleAccountRowData"
            ref="settleAccountsDetailTableRef"
            @confirmChooseDetailHandler="confirmChooseDetailHandler"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="4">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <FileTable ref="fileTableRef" :attachments="attachments" :isShowDownBtn="!isCreate" />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="btn-group">
      <template v-if="isCreate">
        <el-button type="primary" @click="saveOrSubmitHandler(0)">保存</el-button>
        <el-button type="primary" @click="saveOrSubmitHandler(1)">提交审批</el-button>
      </template>
      <template v-if="!isCreate">
        <el-button
          type="primary"
          @click="isCreate = true"
          v-if="['01', '03', '05'].includes(baseFormData.settlementStatus)"
          >编辑</el-button
        >
        <el-button
          type="primary"
          @click="payApplicationHandler"
          v-if="
            ['04'].includes(baseFormData.settlementStatus) && baseFormData.paymentStatus != '01'
          "
          >创建付款申请</el-button
        >
        <el-button
          type="primary"
          @click="isCreate = true"
          v-if="['06'].includes(baseFormData.settlementStatus)"
          >调整</el-button
        >
        <el-button
          type="primary"
          @click="withdrawHandler"
          v-if="
            ['04'].includes(baseFormData.settlementStatus) && baseFormData.paymentStatus == '02'
          "
          >撤回</el-button
        >
        <el-button
          type="primary"
          @click="lockHandler"
          v-if="
            ['04'].includes(baseFormData.settlementStatus) && baseFormData.paymentStatus == '02'
          "
          >锁定</el-button
        >
        <el-button
          type="primary"
          @click="closeHandler"
          v-if="
            ['04'].includes(baseFormData.settlementStatus) && baseFormData.paymentStatus == '01'
          "
          >关闭</el-button
        >
        <el-button
          type="primary"
          @click="printHandler"
          v-if="['04'].includes(baseFormData.settlementStatus)"
          >打印</el-button
        >
      </template>
    </div>
    <Print ref="easyPrint">
      <PrintDemo :content="content" />
    </Print>
    <PrintDialog ref="PrintDialog" @printHandler="DetailPrintHandler"></PrintDialog>
  </div>
</template>

<script>
  import LeaseContractForm from './components/LeaseContractForm/index.js';
  import SettleAccountsRowTable from './components/SettleAccountsRowTable/index.vue';
  import SettleAccountsDetailTable from './components/SettleAccountsDetailTable/index.vue';
  import leaseContractApi from '@/api/receivablesAndPayables/leaseContract.js';
  import { mapNumToString, formatDate } from '@/utils';
  import PAYABLES_TRADE from '@/api/receivablesAndPayables/trade.js';
  import Print from '@/components/Print';
  import PrintDemo from '@/components/Print/printDemo';
  import PrintDialog from '../../../../components/PrintDialog.vue';

  export default {
    name: 'leaseContractDetail',
    mixins: [LeaseContractForm],
    data() {
      return {
        content: '',
        activeNames: ['1', '2', '3', '4'],
        isLoadPage: false,
        isCreate: true,
        isEdit: false,
        attachments: [],
        currentSettleAccountRowData: {}, // 当前选中结算行的数据
        settleAccountsDetailMap: new Map(), // key为结算行的id,
        currentSettleAccountDetailList: [], //明细表数据
        settleAccountsRowList: [], // 全部的行数据
        defaultSelection: null,
      };
    },
    mounted() {
      console.log(
        'ctx.dictListMap?.settlementStatus',
        this.dictListMap?.settlementStatus,
        this.dictListMap?.pay_paymentStatus
      );
      this.isCreate = this.$route.query.status == 'create';
      this.isEdit = this.$route.query.status == 'edit';
      if (this.isEdit) this.isCreate = true;
      if (['create'].includes(this.$route.query?.status)) {
        let selectIdList = this.$route.query?.id;
        console.log(selectIdList, '全部的id');
        if (selectIdList) {
          selectIdList = Array.isArray(selectIdList) ? selectIdList : [selectIdList];
          if (selectIdList.length) {
            this.getDetailDataById(selectIdList);
          }
        }
      }
      if (['edit', 'detail'].includes(this.$route.query?.status)) {
        this._getDetailDataById(this.$route.query?.payNo);
      }
    },
    methods: {
      //打印
      printHandler() {
        this.$refs.PrintDialog.openDialog();
        console.log('打印');
      },
      DetailPrintHandler(val) {
        this.loading.startLoading();
        const params = {
          id: +this.$route.query?.id,
          downloadOrPrint: 'print',
        };
        this.$axios.post(PAYABLES_TRADE.PAYABLELIST_PRINT, params).then((res) => {
          if (res.data.code === 0) {
            this.loading.endLoading();
            if (val == 'pdf') {
              window.open(res.data.data.pdf, '_blank');
            }
            if (val == 'excel') {
              window.open(res.data.data.word, '_blank');
            }
          }
        });
      },
      // 切换合同号,清空结算行数据
      changeContractHandler() {
        this.currentSettleAccountRowData = {}; // 当前选中结算行的数据
        this.settleAccountsDetailMap = new Map(); // key为结算行的id,
        this.currentSettleAccountDetailList = []; //明细表数据
        this.settleAccountsRowList = []; // 全部的行数据
      },
      // 获取详情-->列表进来
      async _getDetailDataById(payNo) {
        if (!payNo) return;
        this.loading.startLoading();
        const { data } = await this.$axios.post(
          `${PAYABLES_TRADE.GET_PAYBLES_SETTLEMENT_DETAIL_BY_NO}/${payNo}`
        );
        this.loading.endLoading();
        console.log(JSON.stringify(data), 'data');
        if (data.code == 0) {
          this.baseFormData = {
            ...mapNumToString(data.data),
            settlementNo: data.data.payableSettlementNo,
            anotherPayFlag: data.data.anotherPayFlag === 0 ? false : true,
          };
          this.$nextTick(() => {
            this.$refs.formItem.clearValidate();
          });
          this.settleAccountsRowList = data.data.lines.map((item) => {
            return {
              ...item,
              createMethod: item.createMethod == '01' ? '系统' : '手动',
            };
          });
          console.log('获取结算行数据', this.settleAccountsRowList);
          this.attachments = data.data.attachments || [];
          // 单独处理如果是有结算行的时候显示明细行出来(第一行)
          if (this.settleAccountsRowList.length) {
            this.currentSettleAccountRowData = this.defaultSelection =
              this.settleAccountsRowList[0];
            this.currentSettleAccountDetailList =
              this.settleAccountsRowList[0]?.lineDetails.map((item) => {
                item.expense = {
                  ...item.expense,
                  settlementBusinessType: item.expense.businessCategory,
                  settlementQuantity: item.expense.statementQuantity,
                  payableSettlementNo: item.expense.settlementNo,
                  businessDocNo: item.expense.businessDocCode,
                };
                return item.expense;
              }) || [];
          }
          console.log('获取结算行明细数据', this.currentSettleAccountDetailList);
        } else {
          this.$message.warning('获取详情失败');
        }
      },
      // 根据id获取详情数据 --> 创建的时候
      async getDetailDataById(selectIdList) {
        const { data } = await this.$axios.post(`${leaseContractApi.GET_DETAIL_BY_IDS}`, {
          ids: selectIdList,
        });
        this.isLoadPage = false;
        console.log(data, '???查询数据');
        if (data.code == 0) {
          this.currentSettleAccountDetailList = data.data.map((item) => {
            return {
              ...item,
              settlementQuantity: item.statementQuantity,
              businessDocNo: item.businessDocCode,
              createMethod: item.createMethod == '01' ? '系统' : '手动',
            };
          });
          // 分类计算计算行
          this.computedSettleAccountsRowByExpenseTypeName(
            data.data.map((item) => {
              console.log('+=====');
              return {
                ...item,
                settlementQuantity: item.statementQuantity,
              };
            })
          );
          // 填充到上面表单(取第一条数据)
          console.log('data=====', data.data[0]);
          this.baseFormData = {
            ...mapNumToString(data.data[0]),
            // 处理汇总原币结算总金额（含税）和 本币结算总金额（含税）TODO 表单中有就用表单的
            ...this.computedTotalAmount(data.data),
            // paidAmount: '0',
            // 如果有值就用返回的,没有就用默认的
            settlementCompanyNo: data.data[0]?.businessCompanyNo || this.userInfo.companyCode,
            settlementCompanyName: data.data[0]?.businessCompanyName || this.userInfo.companyName,
            settlementDepartmentNo:
              data.data[0]?.businessDepartmentCode || this.userInfo.departmentCode,
            settlementDepartmentName:
              data.data[0]?.businessDepartmentName || this.userInfo.departmentName,
            salesmanName: data.data[0]?.salesmanName || this.userInfo.userName,
            salesmanNo: data.data[0]?.salesmanNo || this.userInfo.userCode,
            settlementCreateDate: data.data[0]?.settlementCreateDate || formatDate(new Date()),
            payableAccountPeriod: data.data[0]?.accountPeriod || formatDate(new Date()),
            settlementDate: data.data[0]?.settlementDate || formatDate(new Date()),
            settlementBusinessType: data.data[0]?.businessCategory,
          };
          // delete this.baseFormData?.accountPeriod
          this.baseFormData.unpaidAmount = this.toString(
            this.baseFormData.originalTotalAmount - this.baseFormData.paidAmount
          );
          this.$nextTick(() => {
            this.$refs.formItem.clearValidate();
          });
        } else {
          this.$message.error('获取数据失败');
        }
      },
      // originalAmount domesticAmount
      computedTotalAmount(detailList) {
        const originalTotalAmount = detailList.reduce((pre, cur) => pre + +cur.originalAmount, 0);
        const domesticTotalAmount = detailList.reduce((pre, cur) => pre + +cur.domesticAmount, 0);
        const originalTotalAmountWithoutTax = detailList.reduce(
          (pre, cur) => pre + +cur.originalAmountWithoutTax,
          0
        );
        const originalTotalTaxAmount = detailList.reduce(
          (pre, cur) => pre + +cur.originalTaxAmount,
          0
        );
        const domesticTotalAmountWithoutTax = detailList.reduce(
          (pre, cur) => pre + +cur.domesticAmountWithoutTax,
          0
        );
        const domesticTotalTaxAmount = detailList.reduce(
          (pre, cur) => pre + +cur.domesticTaxAmount,
          0
        );
        return {
          originalTotalAmount:
            originalTotalAmount + '' == 'NaN' ? '0' : Number(originalTotalAmount).toFixed(6) + '',
          domesticTotalAmount:
            domesticTotalAmount + '' == 'NaN' ? '0' : Number(domesticTotalAmount).toFixed(6) + '',
          originalTotalAmountWithoutTax:
            this.replaceZeroStr(originalTotalAmountWithoutTax.toFixed(2)) + '',
          originalTotalTaxAmount: this.replaceZeroStr(originalTotalTaxAmount.toFixed(2)) + '',
          domesticTotalAmountWithoutTax:
            this.replaceZeroStr(domesticTotalAmountWithoutTax.toFixed(2)) + '',
          domesticTotalTaxAmount: this.replaceZeroStr(domesticTotalTaxAmount.toFixed(2)) + '',
          unpaidTotalAmount:
            domesticTotalAmount + '' == 'NaN' ? '0' : Number(domesticTotalAmount).toFixed(6) + '',
        };
      },
      toString(value) {
        return value + '';
      },
      // 根据明细行数据 根据费用类型(根据expenseTypeName分类)汇总到结算行数据
      computedSettleAccountsRowByExpenseTypeName(detailList) {
        console.log('detailList', detailList);
        const expenseTypeNameMap = {};
        for (const item of detailList) {
          let mapItem = expenseTypeNameMap[item.expenseTypeName];
          if (mapItem) {
            mapItem.push(item);
          } else {
            mapItem = [item];
          }
          expenseTypeNameMap[item.expenseTypeName] = mapItem;
        }
        const formatTableList = [];
        for (const key in expenseTypeNameMap) {
          console.log('expenseType', expenseTypeNameMap[key][0].expenseType);
          formatTableList.push({
            settlementDesc: expenseTypeNameMap[key][0].settlementDesc,
            // expenseTypeName: expenseTypeNameMap[key][0].expenseTypeName,
            expenseType: expenseTypeNameMap[key][0].expenseType,
            originalPrice: expenseTypeNameMap[key].reduce(
              (prev, cur) => prev + (+cur.originalPrice ? cur.originalPrice : 0),
              0
            ),
            settlementQuantity:
              [...new Set(expenseTypeNameMap[key].unit)].length > 1
                ? ''
                : expenseTypeNameMap[key].reduce(
                    (prev, cur) => prev + (+cur.settlementQuantity ? cur.settlementQuantity : 0),
                    0
                  ),
            unit:
              [...new Set(expenseTypeNameMap[key].unit)].length > 1
                ? ''
                : expenseTypeNameMap[key][0].unit,
            unitName:
              [...new Set(expenseTypeNameMap[key].unitName)].length > 1
                ? ''
                : expenseTypeNameMap[key][0].unitName,
            originalAmount: expenseTypeNameMap[key]
              .reduce((prev, cur) => prev + (+cur.originalAmount ? cur.originalAmount : 0), 0)
              .toFixed(6),
            businessDocCode:
              [...new Set(expenseTypeNameMap[key].businessDocCode)].length > 1
                ? ''
                : expenseTypeNameMap[key][0].businessDocCode,
            businessDocNo:
              [...new Set(expenseTypeNameMap[key].businessDocCode)].length > 1
                ? ''
                : expenseTypeNameMap[key][0].businessDocCode,
            currencyCode:
              [...new Set(expenseTypeNameMap[key].currencyCode)].length > 1
                ? ''
                : expenseTypeNameMap[key][0].currencyCode,
            currencyName:
              [...new Set(expenseTypeNameMap[key].currencyName)].length > 1
                ? ''
                : expenseTypeNameMap[key][0].currencyName,
            exchangeRate:
              [...new Set(expenseTypeNameMap[key].exchangeRate)].length > 1
                ? ''
                : expenseTypeNameMap[key][0].exchangeRate,
            domesticAmount: expenseTypeNameMap[key]
              .reduce((prev, cur) => prev + (+cur.domesticAmount ? cur.domesticAmount : 0), 0)
              .toFixed(6),
            additional: expenseTypeNameMap[key][0].additional,
            // businessDocNo: expenseTypeNameMap[key][0].businessDocNo,
            remark: expenseTypeNameMap[key][0].remark,
            // 结算明细
            lineDetails: expenseTypeNameMap[key].map((item) => {
              return {
                ...item,
                createMethod: item.createMethod == '01' ? '系统' : '手动',
                businessDocNo: item.businessDocCode,
              };
            }),
            // 扩展字段
            contractNo: expenseTypeNameMap[key][0].contractNo,
          });
        }
        this.settleAccountsRowList = formatTableList;
        // 单独处理如果是有结算行的时候显示明细行出来(第一行)
        if (formatTableList.length) {
          this.currentSettleAccountRowData = this.defaultSelection = formatTableList[0];
          this.currentSettleAccountDetailList = this.currentSettleAccountRowData.lineDetails;
        }
      },
      // 结算行单机一行数据
      selectionRowHandler(rowData) {
        this.currentSettleAccountRowData = rowData;
        if (rowData) {
          // 也可能是数据反填的时候获取的数据，也有可能是手动添加的

          rowData.lineDetails = rowData.lineDetails?.map((item) => {
            item.accountPeriod = item.expense?.accountPeriod || item.accountPeriod;
            item.expenseGenerationDate =
              item.expense?.expenseGenerationDate || item.expenseGenerationDate;
            return item;
          });
          this.currentSettleAccountDetailList = rowData.lineDetails || [];
        }
        console.log(
          rowData,
          '获取结算行',
          this.currentSettleAccountDetailList,
          this.settleAccountsRowList
        );
      },
      // 关闭结算行汇总金额到表单中
      closeEditRowTableHandler(tableData) {
        console.log(tableData, '关闭结算行');
        this.baseFormData = {
          ...this.baseFormData,
          // 处理汇总原币结算总金额（含税）和 本币结算总金额（含税）
          ...this.computedTotalAmount(tableData),
        };
        // 处理未付款金额和已付款金额
        this.baseFormData.unpaidAmount = this.toString(
          Number(this.baseFormData.originalTotalAmount - this.baseFormData.paidAmount).toFixed(6)
        );
        // 最新结算行表格数据
        // this.settleAccountsRowList = tableData;
      },
      // 确认插入明细表数据
      confirmChooseDetailHandler(tableData) {
        console.log(tableData, '111');
        const currentRow = this.settleAccountsRowList.find(
          (item) => item._XID == this.currentSettleAccountRowData._XID
        );
        currentRow.lineDetails = tableData;
        // 根据当前结算明细中的数据汇总到结算行中
        // 更新费用类型
        currentRow.expenseType =
          [...new Set(currentRow.lineDetails?.map((item) => item?.expenseType))].length > 1
            ? ''
            : currentRow.lineDetails[0]['expenseType'];
        // 1.更新编号
        currentRow.businessDocCode =
          [...new Set(currentRow.lineDetails?.map((item) => item?.businessDocCode))].length > 1
            ? ''
            : currentRow.lineDetails[0]['businessDocCode'];
        currentRow.businessDocNo =
          [...new Set(currentRow.lineDetails?.map((item) => item?.businessDocNo))].length > 1
            ? ''
            : currentRow.lineDetails[0]['businessDocNo'];
        // 2.结算单价
        currentRow.originalPrice =
          [...new Set(currentRow.lineDetails?.map((item) => item?.originalPrice))].length > 1
            ? ''
            : currentRow.lineDetails[0]['originalPrice'];
        // 3.数量
        currentRow.settlementQuantity =
          [...new Set(currentRow.lineDetails?.map((item) => item?.unit))].length > 1
            ? ''
            : currentRow.lineDetails.reduce(
                (pre, cur) => pre + (cur.settlementQuantity ? +cur.settlementQuantity : 0),
                0
              );
        // 4.原币结算金额
        currentRow.originalAmount = currentRow.lineDetails
          .reduce((pre, cur) => pre + (cur.originalAmount ? +cur.originalAmount : 0), 0)
          .toFixed(6);
        // 5.本币结算金额
        currentRow.domesticAmount = currentRow.lineDetails
          .reduce((pre, cur) => pre + (cur.domesticAmount ? +cur.domesticAmount : 0), 0)
          .toFixed(6);
        // 6.计量单位
        currentRow.unit =
          [...new Set(currentRow.lineDetails?.map((item) => item?.unit))].length > 1
            ? ''
            : currentRow.lineDetails[0]['unit'];
        currentRow.unitName =
          [...new Set(currentRow.lineDetails?.map((item) => item?.unitName))].length > 1
            ? ''
            : currentRow.lineDetails[0]['unitName'];
        console.log(this.settleAccountsRowList, '引入最终数据');
        // 调用结算行中的关闭表格方法(刷新表格汇总数据)
        this.$refs.settleAccountsRowTableRef.closeEditTableHandler();
      },
      // 删除结算行数据
      deleteRowDataHandler(tableData) {
        this.settleAccountsRowList = tableData;
        console.log(this.settleAccountsRowList, '最终数据');
        // 处理结算明细中
        this.currentSettleAccountRowData = {};
        this.currentSettleAccountDetailList = [];
        // 重新计算到表单中
        this.closeEditRowTableHandler(tableData);
      },
      // 提交或者保存
      async saveOrSubmitHandler(type) {
        const attachments = this.$refs.fileTableRef?.getTableData();
        // 判断表单必填项
        let formRequired = false;
        this.$refs.formItem.validate((valid) => {
          formRequired = valid;
        });
        if (!formRequired) {
          this.$message.error('请检查基本信息填写');
          return;
        }
        // 判断结算行信息必填项
        let checkLinesRefStatus = await this.$refs?.settleAccountsRowTableRef?.validAllEvent();
        if (checkLinesRefStatus) {
          return;
        }
        // 1.判断是否有明细行数据
        const lineDetailsList = this.settleAccountsRowList?.map((item) => item.lineDetails);
        if (!lineDetailsList || lineDetailsList.length == 0) {
          this.$message.error('请补充明细行数据');
          return;
        }
        // 增加unitName
        this.settleAccountsRowList = this.settleAccountsRowList?.map((item) => {
          let temp = item;
          item.lineDetails = item.lineDetails?.map((item1) => {
            return {
              ...item1,
              unitName: this.dictListMap?.LeaseContractChargeUnit.find(
                (item2) => item2.value == item1.unit
              )?.label,
            };
          });
          return {
            ...item,
            unitName: this.dictListMap?.LeaseContractChargeUnit.find(
              (item) => item.value == temp.unit
            )?.label,
          };
        });
        const postData = {
          type,
          ...this.baseFormData,
          companyCode: this.baseFormData.settlementCompanyNo,
          companyName: this.baseFormData.businessCompanyName,
          departmentCode: this.baseFormData.settlementDepartmentNo,
          // 1.自动汇总表格中的数据,避免没点击表格操作,
          // 处理汇总原币结算总金额（含税）和 本币结算总金额（含税）
          ...this.computedTotalAmount(this.settleAccountsRowList),
          anotherPayFlag: this.baseFormData.anotherPayFlag ? 1 : 0,
          lines: this.settleAccountsRowList, // 行数据
          deleteLineIds: this.$refs?.settleAccountsRowTableRef?.ids || [],
          deleteLineDetailIds: this.$refs?.settleAccountsDetailTableRef?.ids || [],
          attachments, // 附件
          settlementBusinessType: '04',
          // settlementDepartmentNo: this.baseFormData.companyCode,
          // settlementCompanyNo:this.baseFormData.businessDepartmentCode,
          oaId: this.userInfo.oaId,
          businessGroup: this.userInfo.businessGroup,
        };
        console.log(postData, '1111');
        this.loading.startLoading();
        const { data } = await this.$axios.post(leaseContractApi.CREATE_OR_SUBMIT, postData);
        this.loading.endLoading();
        if (data.code == 0) {
          console.log(data);
          this.$message.success(`${type == 0 ? '保存成功' : '提交成功'}`);
          let path = {
            fromPath: {
              path: '/receivablesAndPayables/leaseContractDetail',
              name: 'leaseContractDetail',
              meta: {
                keepAlive: true,
                title: '三方租赁应付结算单',
              },
              query: {},
            },
            toPath: {
              path: '/receivablesAndPayables/payableList',
              name: 'payableList',
              meta: { keepAlive: true, title: '应付结算单列表' },
              query: {},
            },
          };
          this.$store.dispatch('tagsView/delView', path.fromPath).then(() => {
            this.$nextTick(() => {
              this.$router.push(path.toPath);
            });
          });
        } else {
          this.$message.error(data.msg);
        }
      },
      // 撤回按钮
      withdrawHandler() {
        this.$confirmAction('确定要撤回?', '撤回提示')
          .then(async () => {
            this.loading.startLoading();
            const { data } = await this.$axios.post(leaseContractApi.WITHDRAW, [
              +this.$route.query.id,
            ]);
            this.loading.endLoading();
            if (data.code == 0) {
              this.$message({
                type: 'success',
                message: this.$t('message.success'),
              });
              this.closeCurrentAndToList();
            } else {
              this.$alert(data.msg);
            }
          })
          .catch(() => {
            this.loading.endLoading();
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 锁住按钮事件
      lockHandler() {
        this.$confirmAction('确定要锁住?', '锁住提示')
          .then(async () => {
            this.loading.startLoading();
            const { data } = await this.$axios.post(leaseContractApi.LOCK, [+this.$route.query.id]);
            this.loading.endLoading();
            if (data.code == 0) {
              this.$message({
                type: 'success',
                message: this.$t('message.success'),
              });
              this.closeCurrentAndToList();
            } else {
              this.$alert(data.msg);
            }
          })
          .catch(() => {
            this.loading.endLoading();
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 关闭按钮事件
      closeHandler() {
        this.$confirmAction('确定要关闭?', '关闭提示')
          .then(async () => {
            this.loading.startLoading();
            const { data } = await this.$axios.post(leaseContractApi.CLOSE, [
              +this.$route.query.id,
            ]);
            this.loading.endLoading();
            console.log(data, '1111');
            if (data.code == 0) {
              this.$message({
                type: 'success',
                message: this.$t('message.success'),
              });
              this.closeCurrentAndToList();
            } else {
              this.$alert(data.msg);
            }
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 付款申请
      async payApplicationHandler() {
        if (this.baseFormData.payPayableSettlementNo) {
          this.$message.error(
            `该预结算单已被终结算单：${this.baseFormData.payPayableSettlementNo}关联,不能发起付款申请!`
          );
          return;
        }
        if (this.baseFormData.originalAmount == '0') {
          this.$message.error('该预结算单原币结算金额(含税)为0,不能发起付款申请!');
          return;
        }
        let postData = {
          id: this.$route.query?.id,
          settlementBusinessType: this.baseFormData.settlementBusinessType,
        };
        // let postData = { id: 41 };
        const { data } = await this.$axios.post(
          PAYABLES_TRADE.PAYBLES_PAYMENTAPPLICATION_API,
          postData
        );
        if (data.code == 0) {
          let path = {
            path: '/payment/paymentApplyAdd',
            name: 'paymentApplyAdd',
            meta: {
              keepAlive: true,
              title: '付款申请单创建',
            },
            query: { isEdit: 'Y', businessType: this.baseFormData.settlementBusinessType },
            params: data.data,
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else {
          this.$message('付款申请失败');
        }
      },
      closeCurrentAndToList() {
        this.$store.dispatch('tagsView/delView', {
          path: '/receivablesAndPayables/leaseContractDetail',
          name: 'leaseContractDetail',
          meta: {
            keepAlive: false,
            title: '',
          },
          query: {},
        });
        this.$router.push({ path: '/receivablesAndPayables/payableList' });
      },
    },
    components: {
      SettleAccountsRowTable,
      SettleAccountsDetailTable,
      Print,
      PrintDemo,
      PrintDialog,
    },
  };
</script>

<style lang="scss" scoped>
  .btn-group {
    padding: 20px 0px;
    box-sizing: border-box;
  }
</style>
